/**
 * @license BCP 0.6.17
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name BCP
 * @description
 *
 * # BCP
 *
 * `BCP` - Billing Control Panel general application module
 */
angular.module("BCP", [
    "ngResource",
    "ngRoute",
    "ngAnimate",
    "ui.bootstrap",
    "angular-loading-bar",
    "angularSpinner",
    "treeControl",
    "b17Resource",
    "customFilters",
    "routes",
    "auth",
    "users",
    "selector",
    'upload',
    "export",
    "prices",
    "promotions",
    "revisions",
    "import",
    "settings",
    "ngAside",
    "ngSanitize",
    "ngCsv",
    "intro"
  ])    
  .run (['b17Service', function (b17Service) {
    // caches all initial data
    b17Service.getConfig();
    b17Service.getGroups();
    b17Service.getProducts();
    b17Service.getProviders();
    // get editions data (price versions without promotions)
    b17Service.getEditions().then(function (editions) {
      if (editions.data && editions.data.data) {
        var versions = editions.data.data.results;
        versions.forEach(function (item) {
          b17Service.getPrices({
            version: item.number,
            legacy: 'true',
          });
        });
      }
    });
    b17Service.getPromotions();
  }]);

})();
